var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 774,
    height: 895,
    viewBox: "0 0 774 895",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M773.1 826.8H0.899902V894.3H773.1V826.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M227.4 409.1H58.6001V835.3H227.4V409.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M471.4 240.3H302.6V835.3H471.4V240.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M715.5 539.9H546.7V835.3H715.5V539.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M118.9 273.9C128.4 266.2 136.4 258.3 142.8 250.1C149.2 241.9 152.4 234.1 152.4 226.7C152.4 222.2 151.3 218.7 149.1 216.2C146.9 213.7 143.6 212.4 139.3 212.4C134.9 212.4 131.4 214.1 129 217.5C126.5 220.9 125.4 225.9 125.6 232.5H82C82.5 220.1 85.4 209.8 91 201.6C96.5 193.4 103.7 187.4 112.6 183.6C121.5 179.8 131.3 177.8 142.2 177.8C161 177.8 175 182.1 184.2 190.6C193.4 199.1 198 210.2 198 223.7C198 238.2 192.7 251.8 182 264.5C171.4 277.2 158.1 288.6 142.2 298.6H199.6V331.9H82.4V301.1C97.2 290.7 109.4 281.6 118.9 273.9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M586.2 320.9C596.3 312.5 610.4 308.2 628.4 308.2C640.2 308.2 650.2 310.1 658.6 313.8C666.9 317.5 673.3 322.5 677.5 328.9C681.8 335.3 683.9 342.4 683.9 350.4C683.9 359.9 681.4 367.5 676.3 373.1C671.2 378.8 665.5 382.6 659.1 384.5V385.3C677.6 391.6 686.9 403.6 686.9 421.3C686.9 430.1 684.7 437.8 680.2 444.6C675.8 451.3 669.3 456.5 660.9 460.3C652.5 464.1 642.5 466 630.8 466C611.7 466 596.5 461.8 585.5 453.3C574.4 444.9 568.6 431.9 568.2 414.4H612.1C611.8 420 613.1 424.3 616 427.4C618.9 430.5 623.3 432 629.1 432C633.5 432 637 430.7 639.5 428.2C642 425.7 643.3 422.3 643.3 418.1C643.3 412.8 641.4 408.9 637.7 406.4C633.9 403.9 627.9 402.6 619.4 402.6H611.4V369.3H619.2C625 369.4 630 368.6 634 366.7C638.1 364.8 640.1 361 640.1 355.3C640.1 351 639 347.7 636.7 345.6C634.4 343.4 631.3 342.4 627.3 342.4C622.9 342.4 619.6 343.8 617.5 346.7C615.4 349.6 614.2 353.1 613.9 357.3H570C570.8 341.5 576.1 329.3 586.2 320.9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M340.4 39.3V0.699951H411.1V153.8H364V39.3H340.4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.6360b7a449ddc01ef3c2e09ad48b7d90.svg";
export { ForwardRef as ReactComponent };